// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB99oAZIcDKW9mD8TGaiyGD7UPIg0sVVFc",
  authDomain: "foundry-2079c.firebaseapp.com",
  projectId: "foundry-2079c",
  storageBucket: "foundry-2079c.firebasestorage.app",
  messagingSenderId: "1039407639476",
  appId: "1:1039407639476:web:1925401ff1287353b5a0e1",
  measurementId: "G-1NF3XHWKWS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export the app instance for use in other parts of the application
export default app;
